import { type RefObject, useCallback } from 'react'

export const useScrollToFocus = (
  containerRef?: RefObject<HTMLElement | null>,
): ((node: HTMLElement | null) => void) => {
  const scrollToFocus = useCallback(
    (node: HTMLElement | null) => {
      if (!node) return

      const container = containerRef?.current
      if (container) {
        const containerRect = container.getBoundingClientRect()
        const nodeRect = node.getBoundingClientRect()
        const deltaTop = nodeRect.top - containerRect.top
        container.scrollTo({
          top: container.scrollTop + deltaTop,
          behavior: 'smooth',
        })
        return
      }
    },
    [containerRef],
  )

  return scrollToFocus
}
